<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-course-edit">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>Delete Log Row?</h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <p>Are you sure?</p>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {

}
</script>
